import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import { LisencePlateContext } from "../../../../contexts";
import styles from "./WareHouse.module.css";
import { useStoreContext } from "../../../../hooks/useStoreContext";
import RenderStatus from "../../../../components/StatusRender";
import { Toast } from "../../../../components";

const cx = classNames.bind(styles);

const Camera = ({ name, status, camID, wareHouseCode,configAi ,index}) => {
  const {
    cameraCode,
    setCameraCode,
    setShowInfo,
    setInfo,
    plate
  } = useContext(LisencePlateContext);
  const [checkCamera, setCheckCamera] = useState(false);
  const companyCode = sessionStorage.getItem("company_code");

  const compareCamera = (codeCam) => {
    let camera = cameraCode.filter((item) => item.camera_code !== codeCam);
    return camera
  };
  const hnadleAddCamera = (code, name, e, status) => {
    if(configAi === "On"){
      setInfo({});
      setShowInfo(false);
      if (status === 0 && cameraCode.length < 2) {
        if (e) {
          let dataAdd = {
            camera_name: name,
            warehouse_code: wareHouseCode,
            camera_code: code,
          };
          setCameraCode([dataAdd, ...cameraCode]);
        } else {
          const camera = compareCamera(code);
          setCameraCode(camera);
          
        }
        setCheckCamera(e);
      } else if (status === 0 && cameraCode.length === 2) {
        let index = cameraCode.findIndex((item) => item.camera_code === code);
        if (index >= 0) {
          const camera = compareCamera(code);
          setCameraCode(camera);
          setCheckCamera(e);
        } else {
          Toast.open("Không được chọn nhiều hơn hai camera", "danger");
        }
      } else {
        Toast.open("Camera đang tắt", "danger");
      }
    }
    else{
      Toast.open("Vui lòng bật dịch vụ nhận diện biển số để lựa chọn camera","info")
    }
  };

  useEffect(() => {
    if (cameraCode.length > 0) {
      const index = cameraCode.findIndex((item) => item.camera_code === camID);
      if (index >= 0) {
        setCheckCamera(true);
      }
    }
  }, [cameraCode, camID]);

  return (
    <div className={cx("item-cam", camID === cameraCode ? "active" : "")}>
      <div className={cx("camera")}>
        <span className={cx("On")}>
          <RenderStatus status={status} companyCode={companyCode} />
          {companyCode === "DEFAULT" ? (
            <p className={cx("tooltip",index === 0 ? 'bottom':'top')}>
              {status === 0
                ? "Đang trực tuyến"
                : status === 3
                ? "Sẵn sàng"
                : "Mất kết nối"}
            </p>
          ) : (
            <p className={cx("tooltip",index === 0 ? 'bottom':'top')}>
              {status === 0 ? "Đang trực tuyến" : "Mất kết nối"}
            </p>
          )}
        </span>
        <span className={cx("name")}>{name}</span>
      </div>
      <input
        checked={checkCamera}
        className={cx("check")}
        type="checkbox"
        onChange={(e) => hnadleAddCamera(camID, name, e.target.checked, status)}
      />
    </div>
  );
};
Camera.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  camID: PropTypes.string.isRequired,
};
export default Camera;
